import { ConnectionStats } from '../../services/api/apiTypes'

export const mapDbStatsToConnectionStats = (databases: string[]): ConnectionStats => {
  return databases.map((db) => ({
    database: db
  }))
}
